import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFunnel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFunnel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ba7cec3b17cafba78ff4067b361f2a31d92e667c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cfade86b3a8f644356c816f7b5b825f01720d6b2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e09619c1fa1908f9049287670a15d0568065840c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.5 18.96a.5.5 0 0 0 .812.39l4-3.2a.5.5 0 0 0 .188-.39V11l4.372-4.857A.5.5 0 0 0 18 5.808V3.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v2.308a.5.5 0 0 0 .128.335L8.5 11zm8-14.46v.924l-4.5 5v4.855l-2 1.6v-6.455l-4.5-5V4.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-funnel", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-funnel"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-funnel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFunnel$1);
            }
            break;
    } });
}

const CosmosIconFunnel = CosmosIconFunnel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFunnel, defineCustomElement };
